import { View } from 'react-native';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { styles } from './styles';

type WrapperProps = {
  onPress?: () => void;
  isDisabled?: boolean;
  isLast?: boolean;
  children: React.ReactNode;
};

export function Wrapper({
  onPress,
  isDisabled,
  isLast,
  children,
}: WrapperProps) {
  return (
    <View style={[!isLast && styles.bottomBorder]}>
      <PressableNeolexon
        style={{ opacity: isDisabled ? 0.6 : 1 }}
        disabled={isDisabled}
        onPress={onPress}
      >
        {children}
      </PressableNeolexon>
    </View>
  );
}
